import React from 'react';

const Details = () => {
    return (
        <div>
            <h1>This is Details</h1>
        </div>
    );
};

export default Details;